const src = 'https://js.stripe.com/v3/';

export default src;